import { render, staticRenderFns } from "./UnsupportedBrowserDialog.vue?vue&type=template&id=4711725e&scoped=true&"
import script from "./UnsupportedBrowserDialog.vue?vue&type=script&lang=js&"
export * from "./UnsupportedBrowserDialog.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportedBrowserDialog.vue?vue&type=style&index=0&id=4711725e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4711725e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDialog,VFlex,VLayout,VRow})
